var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeContentLayout',[_c('p',[_vm._v("活跃用户")]),_c('p',[_vm._v("本页测试长内容，滚动条状态")]),_c('div',{staticClass:"test-content"})])}
var staticRenderFns = []

export { render, staticRenderFns }